import React from "react";
import { PostType } from "../../Post/Post.types";
import { OnReactionEventHandler } from "../Events/OnReactionEvent.types";
import { useOnReaction } from "./useOnReaction";

const isPostType = (param: unknown): param is PostType => {
    return (
        typeof param === "object" &&
        param !== null &&
        "id" in param &&
        "postData" in param
    );
};

export const useOnPostReaction = <T>(
    setter?: (value: React.SetStateAction<T>) => void,
    callback?: OnReactionEventHandler,
) => {
    return useOnReaction("post", (event) => {
        setter?.((oldItems) => {
            if (!Array.isArray(oldItems)) {
                return oldItems;
            }

            const itemIndex = oldItems.findIndex(
                (item) =>
                    isPostType(item) && item.id.toString() === event.entityId,
            );

            if (itemIndex < 0) {
                return oldItems;
            }

            const newItems = JSON.parse(JSON.stringify(oldItems));

            const newItem = newItems[itemIndex];

            if (!isPostType(newItem)) {
                return oldItems;
            }

            newItem.postData.postReactions = JSON.parse(
                JSON.stringify(event.reactions.reactions),
            );

            newItem.postData.reactionCountSum =
                newItem.postData.postReactions?.reduce(
                    (sum, reaction) => sum + reaction.reactionCount,
                    0,
                ) ?? 0;

            newItems[itemIndex] = newItem;

            return newItems;
        });

        callback?.(event);
    });
};
